/**
 * Luxury Brand UI Icons
 * Minimal, elegant icons for navigation and interactions
 */

// Close/X Icon - Elegant, minimal
export const CloseIcon = ({ size = 24, color = '#1A1A1A', strokeWidth = 1.5, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M18 6L6 18M6 6L18 18" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Arrow Left - Minimal, elegant
export const ArrowLeftIcon = ({ size = 24, color = '#1A1A1A', strokeWidth = 1.5, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M19 12H5M12 19L5 12L12 5" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Arrow Right - Minimal, elegant
export const ArrowRightIcon = ({ size = 24, color = '#1A1A1A', strokeWidth = 1.5, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M5 12H19M12 5L19 12L12 19" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Chevron Left - For carousels
export const ChevronLeftIcon = ({ size = 24, color = '#1A1A1A', strokeWidth = 1.5, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M15 18L9 12L15 6" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Chevron Right - For carousels
export const ChevronRightIcon = ({ size = 24, color = '#1A1A1A', strokeWidth = 1.5, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M9 18L15 12L9 6" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// User/Account Icon
export const UserIcon = ({ size = 24, color = '#1A1A1A', strokeWidth = 1.5, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle cx="12" cy="8" r="4" stroke={color} strokeWidth={strokeWidth} />
    <path 
      d="M6 21C6 17.134 9.134 14 13 14C16.866 14 20 17.134 20 21" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round"
    />
  </svg>
);

// Logout Icon
export const LogoutIcon = ({ size = 24, color = '#1A1A1A', strokeWidth = 1.5, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M9 21H5C4.44772 21 4 20.5523 4 20V4C4 3.44772 4.44772 3 5 3H9" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
    <path 
      d="M16 17L21 12L16 7M21 12H9" 
      stroke={color} 
      strokeWidth={strokeWidth} 
      strokeLinecap="round" 
      strokeLinejoin="round"
    />
  </svg>
);

// Play Icon - For videos
export const PlayIcon = ({ size = 24, color = '#1A1A1A', strokeWidth = 1.5, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path 
      d="M8 5V19L19 12L8 5Z" 
      fill={color}
    />
  </svg>
);

// Pause Icon - For videos
export const PauseIcon = ({ size = 24, color = '#1A1A1A', strokeWidth = 1.5, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect x="6" y="4" width="4" height="16" fill={color} />
    <rect x="14" y="4" width="4" height="16" fill={color} />
  </svg>
);

// Loading/Spinner Icon - Elegant
export const LoadingIcon = ({ size = 24, color = '#1A1A1A', className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <circle 
      cx="12" 
      cy="12" 
      r="10" 
      stroke={color} 
      strokeWidth="2" 
      strokeOpacity="0.2"
    />
    <path 
      d="M12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12" 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round"
    />
  </svg>
);

